import React from 'react'; // React core library for building UI
import ReactDOM from 'react-dom/client'; // ReactDOM client for mounting React apps
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'; // provide React Query context
import App from './App.tsx'; // Main application component with routing and layout
import './index.css'; // Global styles applied to the app

// Create a local QueryClient to avoid @bijikyu/qorereact Node.js module issues
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

// Mount the React application in strict mode for development warnings
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
); // render the App component into the root element
